/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";
import { checkLogin } from "actions/AuthAction";
import { loginUser } from "actions/AuthAction";
import { useNavigate, useLocation } from "react-router-dom";
import swal from "sweetalert";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { Navigate } from "react-router-dom";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/bg-sign-in-cover.jpeg";
import eoBG from "assets/images/esaoffice_cover.png";
import eoCover from "assets/images/eo_cover.png";
import eoCover2 from "assets/images/eocover2.png";
import eoCover3 from "assets/images/eocover3.png";
import eoCover4 from "assets/images/eocover4.png";

import eo_mini1 from "assets/images/eo_mini1.png";

import eo_mini4 from "assets/images/eo_mini4.png";

function Cover() {
  const [rememberMe, setRememberMe] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Tambahan state dan logic login
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = location.state?.from || "/dashboards/analytics";
  const [loginProses, setLoginProses] = useState(false);

  // Hapus semua check login untuk menghentikan loop
  // Biarkan user tetap di halaman login sampai mereka submit form

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  function handleChangeEmail(event) {
    setEmail(event.target.value);
  }

  function handleChangePassword(event) {
    setPassword(event.target.value);
  }

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      navigate(redirectTo, { replace: true });
    }
  }, [redirectTo]); // Redirect ke halaman yang dimaksud jika sudah login

  function handleSubmit(event) {
    setLoginProses(true);
    event.preventDefault();
    console.log("🔐 Login attempt started");

    // Validasi input
    if (!email || !password) {
      setLoginProses(false);
      swal({
        title: "Form Tidak Lengkap",
        text: "Email dan Password harus diisi!",
        icon: "warning",
        button: "OK",
      });
      return;
    }

    // Validasi format email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setLoginProses(false);
      swal({
        title: "Format Email Salah",
        text: "Silakan masukkan email yang valid!",
        icon: "error",
        button: "OK",
      });
      return;
    }

    console.log("📧 Email:", email);
    loginUser(email, password, setLoginProses, navigate, redirectTo);
  }

  // Array gambar untuk slider - desktop dan mobile
  const coverImagesDesktop = [eoCover, eoCover2, eoCover3, eoCover4];
  const coverImagesMobile = [eo_mini1, eo_mini4];
  const coverImages = isMobile ? coverImagesMobile : coverImagesDesktop;

  return (
    <CoverLayout images={coverImages}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          mx={2}
          mt={2}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Dengan email and password Rote Smart Service
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                variant="standard"
                fullWidth
                placeholder="john@example.com"
                InputLabelProps={{ shrink: true }}
                value={email}
                onChange={handleChangeEmail}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                variant="standard"
                fullWidth
                placeholder="************"
                InputLabelProps={{ shrink: true }}
                value={password}
                onChange={handleChangePassword}
              />
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                type="submit"
                disabled={loginProses}
              >
                {loginProses ? "Loading..." : "sign in"}
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Don&apos;t have an account?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-up/cover"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Sign up
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
